import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import globalReducer from './global/global.reducer';
import customerReducer from './customer/customer.reducer';
import selectedTabReducer from './selectedTab/selectedTab.reducer';
import createCDReducer from './createCD/createCD.reducer';
import paymentCDReducer from './paymentCD/paymentCD.reducer';
import approvalReducer from './approval/approval.reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['selectedTab', 'customer', 'paymentCD'] // Ex. 'user','interest' in the list - name of reducer store
};

// Import reducer files and add to combineReducers
const rootReducer = combineReducers({
  // Ex. Named to store and exported reducers
  global: globalReducer,
  customer: customerReducer,
  selectedTab: selectedTabReducer,
  createCD: createCDReducer,
  paymentCD: paymentCDReducer,
  approval: approvalReducer
});

export default persistReducer(persistConfig, rootReducer);
